import React from 'react';
import Header from '../../components/customer/Header';
import ProductGrid from '../../components/customer/ProductGrid';
import FeaturedOffers from '../../components/customer/FeaturedOffers';
import {useProducts} from '../../hooks/useProducts'
import styles from './Home.module.css';

const Home = () => {
  
  const {products} =  useProducts({limit: 8})

  console.log('revisando productos', products)

  const featuredProducts = products.filter(p=> p.is_featured).slice(0, 3)
  const primeProducts = products.filter(p => p.is_prime).slice(0, 3)
 
  return (
    <div className={styles.home}>
      <Header />
      
      <main className={styles.main}>
        {/* Banner principal */}
        <div className={styles.heroBanner}>
          <img 
            src="/Ropa.png" 
            alt="Ofertas especiales" 
            className={styles.bannerImage}
          />
          <div className={styles.heroContent}>
            <h1>Bienvenido a MiTienda</h1>
            <p>Descubre las mejores ofertas en tecnología</p>
            <button className={styles.ctaButton}>Ver Ofertas</button>
          </div>
        </div>

        {/* Ofertas destacadas */}
        <section className={styles.section}>
          <h2>Ofertas Destacadas</h2>
          <FeaturedOffers products={featuredProducts} />
        </section>

        {/* Productos populares */}
        <section className={styles.section}>
          <h2>Productos Prime</h2>
          <ProductGrid products={primeProducts} />
        </section>

        {/* Categorías */}
        <section className={styles.section}>
          <h2>Categorías</h2>
          <div className={styles.categories}>
            <a href="/search?category_slug=electronicos" className={styles.categoryCard}>
              <img src="/electronicos.jpg" alt="Electrónicos" />
              <h3>Electrónicos</h3>
            </a>
            <a href="/search?category_slug=hogar" className={styles.categoryCard}>
              <img src="/hogar.jpg" alt="Hogar" />
              <h3>Hogar</h3>
            </a>
            <a href="/search?category_slug=deportes" className={styles.categoryCard}>
              <img src="/deportes.jpg" alt="Deportes" />
              <h3>Deportes</h3>
            </a>
          </div>
        </section>
      </main>

      <footer className={styles.footer}>
        <p>&copy; 2025 NexaGlobal. Todos los derechos reservados.</p>
      </footer>
    </div>
  );
};

export default Home;